module.exports = __webpack_public_path__ + "assets/images/daily_activity_r.f77623de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/daily_activity_r.png
// module id = 696
// module chunks = 1